import useAuthStore from '@/stores/useAuthStore';

export default function useUserId() {
  const uid = useAuthStore((state) => state.uid);
  return uid || '';
}
